import { DefaultComSubmitFnSubmissionProp } from './_types';

export const DEFAULT_COM_FORM_ID = 825959;
export const DEFAULT_COM_SEC_RUNTIME_DEMO_FORM_ID = 827539;
export const DEFAULT_COM_DBO_DEMO_FORM_ID = 919903;

const DEFAULT_COM_TEAM_ID = 470;

export const DEFAULT_COM_SUBMISSION_CONFIG_BASE: Omit<
  DefaultComSubmitFnSubmissionProp,
  'responses' | 'form_id'
> = {
  team_id: DEFAULT_COM_TEAM_ID,
  questions: [
    {
      id: 'email',
      name: 'Email',
      type: 'email',
      options: [],
    },
    {
      id: 'name',
      name: 'Name',
      type: 'text',
      options: [],
    },
  ],
};
